import { render, staticRenderFns } from "./MoveToFixedBiMonthlyCheckPopup.vue?vue&type=template&id=7000204a&scoped=true"
import script from "./MoveToFixedBiMonthlyCheckPopup.vue?vue&type=script&lang=js"
export * from "./MoveToFixedBiMonthlyCheckPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedBiMonthlyCheckPopup.vue?vue&type=style&index=0&id=7000204a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000204a",
  null
  
)

export default component.exports